import React from "react"
import { Navigate, Outlet } from "react-router-dom"
import { selectSignedIn } from "store/auth.slice"
import { useAppSelector } from "hooks"

const AuthLayout: React.FC = () => {
	const signedIn = useAppSelector(selectSignedIn())
	if (signedIn) return <Navigate to={`/`} />

	return <Outlet />
}

export default AuthLayout
